import React from 'react';

import classes from './styles.module.scss';

export default function Image({ url }) {
  return <img className={classes.Image} src={url} alt="" />;
}
